import { InputBase } from "@mui/material";
import { useId } from "react";
import {
	type Control,
	Controller,
	type FieldPath,
	type FieldValues,
} from "react-hook-form";
import { StackedField } from "web_myplann/Shared/Components/StackedField";

type Props<
	FormType extends FieldValues,
	TName,
	TContext,
	TTransformed extends FieldValues | undefined,
> = {
	control: Control<FormType, TContext, TTransformed>;
	name: TName;
	label: string;
	placeholder?: string;
};

export const FormTextField = <
	FormType extends FieldValues,
	TName extends FieldPath<FormType>,
	TContext = unknown,
	TTransformed extends FieldValues | undefined = undefined,
>({
	control,
	name,
	label,
	placeholder,
}: Props<FormType, TName, TContext, TTransformed>) => {
	const inputId = useId();

	return (
		<Controller
			control={control}
			name={name}
			render={({
				field: { value, onChange, onBlur, ref },
				fieldState: { error },
			}) => (
				<StackedField label={label} htmlFor={inputId} error={error?.message}>
					<InputBase
						variant="field"
						error={!!error}
						id={inputId}
						fullWidth
						placeholder={placeholder}
						value={value ?? ""}
						onChange={onChange}
						onBlur={onBlur}
						inputRef={ref}
					/>
				</StackedField>
			)}
		/>
	);
};
